<template>
  <div :class="['time_counter_box', {ending: timerInSeconds <= timerEndingLimitStartInSeconds }]">
    <div class="flex-row">
      <img src="/static/images/game/timer_icon.svg">

      <div class="time_counter">
        {{ timerInSeconds |  formatTimerFilter }}
      </div>
    </div>
  </div>
</template>

<script>
import {formatTime} from '../../../helpers/common'

export default {
  name: 'Timer',
  emits: ['time:expired'],
  props: {
    initialTimerInSeconds: {
      type: Number,
      default: 60
    }
  },
  filters: {
    formatTimerFilter: value => formatTime(value, '00:00')
  },
  data () {
    return {
      timerInSeconds: 0,
      timerIntervalId: null,
      timerIntervalDelay: 1000,
      timerEndingLimitStartInSeconds: 10
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.startTimer()
    })
  },
  methods: {
    startTimer (initialTimer) {
      this.timerInSeconds = initialTimer || this.initialTimerInSeconds

      this.timerIntervalId = setInterval(() => {
        --this.timerInSeconds

        if (this.timerInSeconds <= 0) {
          clearInterval(this.timerIntervalId)
          this.timerIntervalId = null

          this.$emit('time:expired')
        }
      }, this.timerIntervalDelay)
    },
    stopTimer () {
      if (this.timerIntervalId) {
        clearInterval(this.timerIntervalId)
      }
    }
  },
  beforeDestroy () {
    this.stopTimer()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/game/Timer.vue